<template>
    <div class="container lms-wrapper-two">
        <student-nav />
        <div class="lms-content">
            <student-header ref="lmsv4header" class="filled" @on-home-stat="onHomeStat" />
            <div class="lms-content-body" style="height: calc(100vh - 110px); overflow: auto">
                <div class="bg-white rounded-20 mg-30 pd-30" >
                    <div class="row">
                        <div class="text-center col-sm-12 col-lg-4 bd-r bd-1">
                            <div class="d-flex justify-content-center mg-y-20">
          <!-- <img
            :src="`${$store.state.user.userInfo.avator}`"
            class="rounded-circle wd-100 ht-100"
          /> -->




          <simple-uploader
                
                :propObjectId="6"
                :propObjectTypeId="6"
                @on-success="fileUploaded"
                class="wd-100 v4upldr d-none d-xl-block"
                propAccept="image/png, image/jpeg, image/jpg, image/bmp"
              >
                <div slot="trigger" class="wd-100 ht-100 rounded-circle">
                  <a
                    v-if="
                      profile.defaultAttachmentId == 0 ||
                      profile.defaultAttachmentId == null
                    "
                    class="dropdown-item"
                    >Энд дарж зураг оруулна уу.</a
                  >
                  <div v-else class="pos-relative">
                    <div class="">
                      <img :src="`${avatar.uploadedUrl}`" class="rounded-circle wd-100 ht-100" alt />
                    </div>
                    <div class="pos-absolute l-35 b-5 btn btn-icon btn-xs btn-primary rounded-circle">
                        <feather type="camera" class="tx-white"></feather>
                    </div>
                  </div>
                </div>
                <!-- <div v-else slot="content" class="wd-100p"></div>-->
              </simple-uploader>

        </div>
                        
                            <div class="pd-t-20 tx-16 font-weight-bold">
                                {{ $store.state.user.userInfo.ovog }}
                                {{ $store.state.user.userInfo.ner }}
                            </div>
                            <div class="tx-14 text-muted">
                                {{ $store.state.user.userInfo.position }}
                            </div>

             
                            <nav class="mt-4 nav nav-sidebar tx-13">
              <a
                v-if="$store.state.app.activeGroup.id != 9249"
                :href="`${$store.state.app.activeGroup.id == 9254?'/academy':''}/#/user/settings/1`"
                class="nav-link"
                :class="{ active: $route.params.mode == '1' }"
              >
                <feather class="ht-25-f wd-25-f" type="lock"></feather>
                <span>Нууц үг солих</span>
                <span class="badge"
                  ><feather type="chevron-right"></feather
                ></span>
              </a>
              <a
                v-if="$store.state.app.activeGroup.id != 9249"
                :href="`${$store.state.app.activeGroup.id == 9254?'/academy':''}/#/user/settings/2`"
                class="nav-link"
                :class="{ active: $route.params.mode == '2' }"
              >
                <feather class="ht-25-f wd-25-f" type="mail"></feather>
                <span>И-мэйл солих</span>
                <span class="badge"
                  ><feather type="chevron-right"></feather
                ></span>
              </a>
              <a
                :href="`${$store.state.app.activeGroup.id == 9254?'/academy':''}/#/user/settings/3`"
                class="nav-link"
                :class="{ active: $route.params.mode == '3' }"
              >
                <feather class="ht-25-f wd-25-f" type="mail"></feather>
                <span>Хоёр нөхцөлт баталгаажуулалт</span>
                <span class="badge"
                  ><feather type="chevron-right"></feather
                ></span>
              </a>
              <router-link
              v-if="$store.state.app.activeGroup.id != 9249"
              :to="{ name: 'userProfile' }"
              class="nav-link"
            >
            <feather class="ht-25-f wd-25-f" type="user"></feather>
              Мэдээлэл шинэчлэх
              <span class="badge"
                  ><feather type="chevron-right"></feather
                ></span>
            </router-link>  
            </nav>

            <ul class="mt-3 list-group" v-if="$store.state.app.activeGroup.id == 9157">
                <li class="list-group-item d-flex align-items-center bg-light">
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="bg-gray-500 avatar-initial rounded-circle"
                      >1</span
                    >
                  </div>
                  <div class="text-left">
                    <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                      {{ profile.loginName }}
                    </h6>
                    <span class="d-block tx-11 text-muted">
                      Гэрчилгээнийй дугаар
                    </span>
                  </div>
                </li>
                <li class="list-group-item d-flex align-items-center bg-light">
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="bg-gray-500 avatar-initial rounded-circle"
                      >2</span
                    >
                  </div>
                  <div class="text-left">
                    <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                      {{ profile.langCode }}
                    </h6>
                    <span class="d-block tx-11 text-muted">Регистрийн дугаар</span>
                  </div>
                </li>
                <li class="list-group-item d-flex align-items-center bg-light">
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="bg-gray-500 avatar-initial rounded-circle"
                      >3</span
                    >
                  </div>
                  <div class="text-left">
                    <h6 class="tx-11 tx-inverse tx-semibold mg-b-0">
                      {{ flat1 }}
                    </h6>
                    <span class="d-block tx-11 text-muted">Гишүүний төрөл</span>
                  </div>
                </li>
                <li class="list-group-item d-flex align-items-center bg-light">
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="bg-gray-500 avatar-initial rounded-circle"
                      >4</span
                    >
                  </div>
                  <div class="text-left">
                    <h6 class="tx-11 tx-inverse tx-semibold mg-b-0">
                      {{ flat2 }}
                    </h6>
                    <span class="d-block tx-11 text-muted">Харьяалагдаж буй салбар</span>
                  </div>
                </li>
                <li 
                  class="list-group-item d-flex align-items-center bg-light"
                >
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="bg-gray-500 avatar-initial rounded-circle"
                      >5</span
                    >
                  </div>
                  <div class="text-left">
                    <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                      {{ profile.unit == 1 ? "Тийм" : "Үгүй" }}
                    </h6>
                    <span class="d-block tx-11 text-muted">Аудитор эсэх</span>
                  </div>
                </li>
              </ul>

                            <div class="pd-x-30 mg-t-50">
                                <div class="d-flex">
                                    <div class="font-weight-bold">Нийт үзсэн сургалт:</div>
                                    <div class="mg-l-auto text-muted">{{dashboard.stat.certificateCount}}</div>
                                </div>
                                <div class="d-flex mg-t-10">
                                    <div class="font-weight-bold">Одоо үзэж буй сургалт:</div>
                                    <div class="mg-l-auto text-muted">{{dashboard.stat.notFinishedCount}}</div>
                                </div>
                            </div>
                        
                        </div>
                        <div class="col-8 pd-y-0 pd-l-20 d-none d-xl-block">
                        <div class="font-weight-bold tx-26">Үзэж буй сургалтууд</div>
                            <div class="course-list row list-list" style="overflow-y: auto; height: calc(100vh - 270px)">




                                <div
            v-for="(r, ci) in courses"
            :key="`${ci}_v4`"
            class="course-item col-12 pd-0"
          >
            <!-- <div :class="`${getCourseFlagBg(r)} course-tag pos-absolute r-10 t-45 text-white pd-x-20 pd-y-1 tx-14`">
              {{getCourseFlag(r)}}
            </div> -->
            <div @click="goToCourse(r)" class="bg-white pd-15 rounded-20 item-outer" role="button">
              <img :class="`cover rounded-20 wd-100p ${listMode==2?'ht-120':''}`" :src="`${r.cover}?w=200&h=100&mode=crop`" />
              <div class="item-info pd-10 d-flex align-items-center">
                <div class="media">
                  <img
                        v-if="r.teachers != null && r.teachers.length > 0"
                        :src="`${r.teachers[0].cover}?w=60&h=60&mode=crop`"
                        :alt="r.teachers[0].name"
                        :title="r.teachers[0].name"
                        class="rounded-circle mg-r-10 wd-60 ht-60"
                      />
                      <img
                        v-else
                        src="assets/img/default.png?w=60&h=60&mode=crop"
                        alt
                        class="rounded-circle mg-r-10 wd-60 ht-60"
                      />
                </div>
                <div class="media-body">
                  <div :class="`course-name tx-${listMode==2?'16':'13'} font-weight-bold lh-1`" :title="r.name">{{r.name}}</div>
                  <div v-if="r.locType1!=null" class="text-muted tx-10 mg-y-3">{{r.locType1.name}} <span v-if="r.myShare!=null">{{r.myShare.percent}}</span></div>
                  <div class="d-flex">
                    <div>
                      <img class="ht-15 wd-15" :src="`${myResBaseUrl}v4-assets/svgicon/user/outline/user.svg`" /> <span class="tx-10 text-muted">{{r.userCount}}</span>
                    </div>
                    <div class="mg-l-10">
                      <Rate v-model="r.rate" :allow-half="true" :disabled="true" size="large" ></Rate>
                    </div>
                  </div>
                </div>
              </div>
              <div class="course-view justify-content-center align-items-center mg-l-auto ">
                <div v-if="$route.params.md == 1" class="btn-group rounded-20">
                  <template v-if="r.myShare != null">
                    <router-link v-if="r.firstLessonId > 0" :to="{ name: 'lmsLessonView', params: { id: r.firstLessonId, cid: r.id, bid: 0, iid: 0, bot: 0 } }" class="btn btn-white ">Үзэх</router-link>  
                    <router-link v-else :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" class="btn btn-white ">Дэлгэрэнгүй</router-link>  
                  </template>
                  <!-- <button v-else @click="courseInfo(r)" type="button" class="btn btn-white ">
                    {{r.option.joinType == 9900 || r.option.directJoin == 1 ? "Элсэх" : "Бүртгүүлэх"}}
                  </button> -->
                  <button v-else-if="r.option!=undefined && r.option!=null && (r.option.joinType == 9900 || r.option.directJoin == 1)" 
                    class="btn btn-white" @click="beforeJoinToCourse(r)" role="button">
                    Үзэх
                  </button>
                  <router-link v-else class="btn btn-white" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">
                    <!-- {{r.option.joinType == 9900 || r.option.directJoin == 1 ? "Элсэх" : "Бүртгүүлэх"}} -->
                    Дэлгэрэнгүй
                  </router-link>
                  <!-- <button @click="courseInfo(r)" type="button" class="btn btn-white ">Танилцах</button> -->
                </div>
                <div v-else-if="$route.params.md == 2" class="btn-group rounded-20">                  
                  <template v-if="r.myShare != null">
                    <router-link v-if="r.firstLessonId>0" class="btn btn-white rounded-20" :to="{ name: 'lmsLessonView', params: { id: r.firstLessonId, cid: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">Үзэх</router-link>
                    <router-link v-else class="btn btn-white rounded-20" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">Дэлгэрэнгүй</router-link>
                  </template>
                  <!-- <button v-else @click="courseInfo(r)" class="btn btn-white rounded-20" type="button" >Элсэх</button> -->
                  <button v-else-if="r.option!=undefined && r.option!=null && (r.option.joinType == 9900 || r.option.directJoin == 1)" 
                    class="btn btn-white" @click="beforeJoinToCourse(r)" role="button">
                    Үзэх
                  </button>
                  <router-link v-else class="btn btn-white rounded-20" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">
                    Дэлгэрэнгүй
                  </router-link>
                  <!-- <button @click="courseInfo(r)" class="btn btn-white rounded-20" type="button">Танилцах</button> -->
                </div>
                <div v-else-if="$route.params.md == 3" class="btn-group rounded-20">
                  <template v-if="r.myShare!=null">
                    <router-link v-if="r.firstLessonId>0" class="btn btn-white rounded-20" :to="{ name: 'lmsLessonView', params: { id: r.firstLessonId, cid: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">Үзэх</router-link>
                    <router-link v-else class="btn btn-white rounded-20" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">Дэлгэрэнгүй</router-link>
                  </template>
                  <!-- <button v-else class="btn btn-white rounded-20" @click="courseInfo(r)" type="button">Тухай</button> -->
                </div>
                <div v-else-if="$route.params.md == 4" class="btn-group rounded-20">
                  <button v-if="r.certificateView" @click="showCertificate(r)" class="btn btn-secondary rounded-20">Сертификат</button>
                  
                  <template v-if=" r.option.canViewAfterFinish != undefined && r.option.canViewAfterFinish ">
                    <router-link v-if="r.firstLessonId>0" :to="{ name: 'lmsLessonView', params: { id: r.firstLessonId, cid: r.id, bid: 0, iid: 0, bot: 0 } }" type="button" class="btn btn-white rounded-20">
                      Үзэх
                    </router-link>
                    <router-link v-else :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button" class="btn btn-white rounded-20">
                      Дэлгэрэнгүй
                    </router-link>
                  </template>
                  <button v-if="r.option.canViewExamResult" @click="showMark(r)" class="btn btn-success " type="button">Дүн харах</button>
                </div>
              </div>
            </div>
          </div>


                            </div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import "element-ui/lib/theme-chalk/index.css";
import { Rate } from "element-ui";

import { request } from "@/api/all";

export default {
    components:{
        Rate,
        simpleUploader: () => ({
            component: import("@/components/modules/media/simpleUploader.vue"),
            loading: AsyncLoading,
            error: AsyncLoadError,
            delay: 100,
            timeout: 5000,
        }),
        studentHeader: () => ({
            component: import("@/views/modules/lms/student/components/header.vue"),
            loading: AsyncLoading,
            error: AsyncLoadError,
            delay: 100,
            timeout: 5000
        }),
        studentNav: () => ({
            component: import("@/views/modules/lms/student/components/nav.vue"),
            loading: AsyncLoading,
            error: AsyncLoadError,
            delay: 100,
            timeout: 5000,
        }),
    },
    data(){
        return{
          flat1: "",
          flat2: "",
          courses: [],
          now: null,
          listMode: 2,
          dashboard:{
              stat:{
                  certificateCount: null,
                  notFinishedCount: null,
              }
          },
          avatar: {
              uploadedUrl: "",
          },
          profile:{

          },
          myResBaseUrl: "https://res.gosmart.mn/"
        }
    },
    created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
    mounted(){
        this.avatar.uploadedUrl = this.$store.state.user.userInfo.avator;
        this.init();
        this.initProfile();
    },
    methods:{
      getLocTypeDisplayString(id) {
      //return id;
      request({
        api: { method: "GET", url: "type/GetFlatType" },
        params: { id: id, sep: " / " },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.flat1 = res.data.flatted;
        }
      });
    },
    getDepartDisplayString(id) {
      request({
        api: { method: "GET", url: "hr/GetFlatDepart" },
        params: { id: id, sep: " / " },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.flat2 = res.data.flatted;
        }
      });
    },
        saveImg() {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Task/PostInherited" },
          data: { model: this.profile },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.handleUserInfo({ store: this.$store });
            //console.log('get inherited', res);
            Notification.success({
              title: "Амжилттай",
              message: `Мэдээлэл шинэчиллээ`,
              duration: 30000,
              position: "bottom-left",
            });
          }
        });
    },

        initProfile(){
            let _pid = 0;
            let prj = this.$store.state.app.groupDefaultProjects.filter((x) => x.objectTypeId == parseInt(138, 10) );
            if (prj.length > 0) _pid = prj[0].id;
            let _uid = this.$store.state.user.userInfo.profileId;;
            //console.log('_uid', _uid);
            request({
                api: { method: "GET", url: "Task/GetInherited" },
                params: {
                id: _uid,
                objectTypeId: 138,
                parentId: 0,
                projectId: _pid,
                boxId: 0,
                userId: this.$store.state.user.userInfo.userId,
                },
                store: this.$store,
            }).then((res) => {
                this.profile = res.data.task;
                request({
                api: { method: "GET", url: "task/taskInheritedDetail" },
                params: { id: this.profile.id },
                store: this.$store,
                }).then((res) => {
                this.profile = res.data.task;
                this.avatar.uploadedUrl = this.$store.state.user.userInfo.avator;
                this.getLocTypeDisplayString(this.profile.locTypeId4);
                this.getDepartDisplayString(this.profile.departId);
                });
            });

        },
        fileUploaded(e) {
            this.avatar.uploadedUrl = e.uploadedUrl;
            this.profile.defaultAttachmentId = e.uploadedAttachmentId;

            this.saveImg();
        },
        onHomeStat(e){
            this.dashboard= e.dashboard;
            //console.log('e', e);
        },
        toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    goToCourse(r){
        if(r.firstLessonId!=undefined && r.firstLessonId>0){
            this.$router.push({name: 'lmsLessonView', params: {id: r.firstLessonId, cid: r.id, bot: 0, bid: 0, iid: 0 } });
        }else{
            this.$router.push({name: 'lmsCourseView', params: {id: r.id, bot: 0, bid: 0, iid: 0 } });
        }
    },
        init(){

          this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                api: { method: "POST", url: 'v2/Learn/myJoinedCourses' },
                data: { skip: 0, size: 32, },
                store: this.$store
            }).then(res => {
                this.fetching= false;
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                this.courses = res.data.courses;
                this.now = res.data.now;
                }
          });

        }
    }
}
</script>
<style lang="less">
.v4upldr{
    .el-upload-dragger{
        border-radius: 50%;
    }
}
</style>